import { render, staticRenderFns } from "./BrandSection.vue?vue&type=template&id=4f897030&scoped=true"
import script from "./BrandSection.vue?vue&type=script&lang=js"
export * from "./BrandSection.vue?vue&type=script&lang=js"
import style0 from "./BrandSection.vue?vue&type=style&index=0&id=4f897030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f897030",
  null
  
)

export default component.exports